import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store/modules'
import NotificationSystem from '@/components/NotificationSystem.vue'
import Swal from 'sweetalert2'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '@/assets/css/global.css'
import axios from 'axios'

// Inicializar gestor de tema
import themeManager from '@/store/theme'

// Hacer SweetAlert2 disponible globalmente
window.Swal = Swal

const app = createApp(App)

// Hacer el gestor de tema disponible globalmente
app.config.globalProperties.$theme = themeManager

// Registrar sistema de notificaciones globalmente
app.component('NotificationSystem', NotificationSystem)

// Inicializar tema al arrancar la app
themeManager.init()

// Configurar axios por defecto para mantener el mismo baseURL y auth
// que el cliente api. Se elimina '/api' final para evitar duplicados.
const rawApiBase = process.env.VUE_APP_API_BASE_URL || ''
axios.defaults.baseURL = rawApiBase.replace(/\/api\/?$/, '') || ''
axios.defaults.headers.common['Content-Type'] = 'application/json'

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token_acceso_admin') || localStorage.getItem('access_token')
  if (token) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, (err) => Promise.reject(err))

app.use(store)
app.use(router)
app.mount('#app')
